import { init, formula } from "expressionparser";
import { ExpressionValue } from "expressionparser/dist/ExpressionParser";
import { format, addDays, addMonths, startOfDay, addYears, startOfMonth, startOfYear, addHours, addMinutes, subDays, subHours, subMinutes, subMonths, subYears } from "date-fns";

//expressionparser-library doesn't handle date-type, use string-wrappers internally
const D = (value: string | number | Date): Date => new Date(value);
const S = (value: Date): string => value.toISOString();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const customFunctions: { [key:string]: ((...args: any) => any) } = {
  'addDays': (date,amount) => S(addDays(D(date), amount)),
  'addHours': (date,amount) => S(addHours(D(date), amount)),
  'addMinutes': (date,amount) => S(addMinutes(D(date), amount)),
  'addMonths': (date,amount) => S(addMonths(D(date), amount)),
  'addYears': (date,amount) => S(addYears(D(date), amount)),
  'format': (date,pattern) => format(D(date),pattern),
  'now': () => S(new Date()),
  'startOfDay': (date) => S(startOfDay(D(date))),
  'startOfMonth': (date) => S(startOfMonth(D(date))),
  'startOfYear': (date) => S(startOfYear(D(date))),
  'subDays': (date,amount) => S(subDays(D(date), amount)),
  'subHours': (date,amount) => S(subHours(D(date), amount)),
  'subMinutes': (date,amount) => S(subMinutes(D(date), amount)),
  'subMonths': (date,amount) => S(subMonths(D(date), amount)),
  'subYears': (date,amount) => S(subYears(D(date), amount)),
};

const parser = init(formula, (term: string) => {
  if (term in customFunctions) {
    return customFunctions[term];
  } else {
    throw new Error(`Invalid term: ${term}`);
  }
}, (term: string) => {
  return term in customFunctions ? "function" : undefined;
});

export const isExpression = (expression: string): boolean => {
  return expression?.startsWith("{{") && expression.endsWith("}}");
}

export const removeExpressionBrackets = (expression: string): string => {
  if(isExpression(expression)) {
    return expression.substring(2,expression.length-2);
  }
  return expression;
}

export const parseExpression = (expression: string, terms?: Record<string, ExpressionValue>): ExpressionValue => {
  return parser.expressionToValue(expression, terms);
};
